import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChartsModule } from "ng2-charts";
import { NgApexchartsModule } from "ng-apexcharts";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { CardSnippetModule } from "@core/components/card-snippet/card-snippet.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { CoreCommonModule } from "@core/common.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectConfig, NgSelectModule } from "@ng-select/ng-select";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { RouterModule } from "@angular/router";
import { ToastrModule } from "ngx-toastr";
import { CsvModule } from "@ctrl/ngx-csv";
import { CoreSidebarModule } from "@core/components";
import { InputPhoneComponent } from "./components/input-phone/input-phone.component";
import { IntlInputPhoneModule } from "intl-input-phone";
import { NgxMaskModule } from "ngx-mask";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { PaginatorComponent } from "./components/paginator/paginator.component";
import { RelativeDatePipe } from "./pipes/relative-date.pipe";
import { NotificationsListComponent } from "./components/notifications-list/notifications-list.component";
import { OnlyIntegerDirective } from "./directives/only-integer.directive";
import { MinutesSecondsPipe } from "./pipes/cooldown.pipe";
import { TemplateViewComponent } from "./components/template-view/template-view.component";
import { SanitizeHTMLPipe } from "./pipes/sanitize-html.pipe";
import { HighlightPersonalizedPipe } from "./pipes/hightlight-personalized.pipe";
import { BufferToStringPipe } from "./pipes/buffer-to-string.pipe";
import { TzDetailsComponent } from "app/main/shared/components/tz-details/tz-details.component";
import { FirstInitialPipe } from "./pipes/first-initial.pipe";
import {
  SendTypeColorPipe,
  SendTypeIconPipe,
} from "app/main/shared/pipes/send-type-color.pipe";
import { FileUploadComponent } from "app/main/shared/components/file-upload/file-upload.component";
import { FileUploadModule } from "ng2-file-upload";
import { IsRequiredDirective } from "app/main/shared/directives/field-required.directive";
import { ErrorMessagePipe } from "app/main/shared/pipes/error-message.pipe";
import { HelpIconComponent } from "app/main/shared/components/help-icon/help-icon.component";
import { ProductIconComponent } from "app/main/shared/components/product-icon/product-icon.component";
import { AlertComponent } from "app/main/shared/components/alert/alert.component";
import { LoadingSpinnerDirective } from "app/main/shared/directives/loading-spinner.directive";
import { InputPhoneV2Component } from "app/main/shared/components/input-phone-v2/input-phone.component";
import { EmgStatusNamePipe } from "./pipes/emg-status-name.pipe";
import { EmgStatusBgPipe } from "./pipes/emg-status-bg.pipe";
import { SupportCardComponent } from "./components/support-card/support-card.component";
import { CopyToClipboardDirective } from "app/main/shared/directives/copy-to-chipboard.directive";
import { CopyToClipboardComponent } from "app/main/shared/components/copy-to-clipboard/copy-to-clipboard.component";
import { TrimPipe } from "app/main/shared/pipes/trim.pipe";
import { LabelSpacerDirective } from './directives/label-spacer.directive';
@NgModule({
  declarations: [
    InputPhoneComponent,
    SidebarComponent,
    PaginatorComponent,
    NotificationsListComponent,
    OnlyIntegerDirective,
    TemplateViewComponent,
    TzDetailsComponent,
    FileUploadComponent,
    HelpIconComponent,
    ProductIconComponent,
    AlertComponent,
    InputPhoneV2Component,
    SupportCardComponent,
    CopyToClipboardComponent,

    // * Directives
    IsRequiredDirective,
    LoadingSpinnerDirective,
    CopyToClipboardDirective,
    LabelSpacerDirective,

    // * Pipes
    MinutesSecondsPipe,
    HighlightPersonalizedPipe,
    BufferToStringPipe,
    TzDetailsComponent,
    FirstInitialPipe,
    SanitizeHTMLPipe,
    RelativeDatePipe,
    SendTypeIconPipe,
    SendTypeColorPipe,
    ErrorMessagePipe,
    EmgStatusNamePipe,
    EmgStatusBgPipe,
    TrimPipe,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    NgSelectModule,
    NgbModule,
    IntlInputPhoneModule,
    NgxMaskModule.forRoot(),
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot(),
    NgxDatatableModule,
    FileUploadModule,
  ],
  exports: [
    // * Modules
    CoreCommonModule,
    ChartsModule,
    NgApexchartsModule,
    NgbModule,
    Ng2FlatpickrModule,
    CardSnippetModule,
    ContentHeaderModule,
    TranslateModule,
    FormsModule,
    NgSelectModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    SweetAlert2Module,
    RouterModule,
    SweetAlert2Module,
    ToastrModule,
    CsvModule,
    NgSelectModule,
    CoreSidebarModule,

    // * Components
    SidebarComponent,
    PaginatorComponent,
    InputPhoneComponent,
    TemplateViewComponent,
    TzDetailsComponent,
    FileUploadComponent,
    HelpIconComponent,
    ProductIconComponent,
    AlertComponent,
    InputPhoneV2Component,
    SupportCardComponent,
    CopyToClipboardComponent,

    // * Directives
    OnlyIntegerDirective,
    IsRequiredDirective,
    LoadingSpinnerDirective,
    CopyToClipboardDirective,
    LabelSpacerDirective,

    // * Pipes
    RelativeDatePipe,
    MinutesSecondsPipe,
    BufferToStringPipe,
    HighlightPersonalizedPipe,
    FirstInitialPipe,
    SendTypeIconPipe,
    SendTypeColorPipe,
    ErrorMessagePipe,
    EmgStatusNamePipe,
    EmgStatusBgPipe,
    TrimPipe,
  ],
})
export class SharedModule {
  constructor(private config: NgSelectConfig) {
    this.config.appendTo = "body";
  }
}
